import jwt_decode from 'jwt-decode'
import { useCallback, useEffect, useMemo, useState } from 'react'
import pubsub from 'pubsub-js'
import { getPendingOnboardingSurvey } from '../OnboardingSurvey/onboardingSurveyApi'
import {
  clearDismissedSurveyType,
  getDismissedSurveyType,
  setDismissedSurveyType,
} from '../OnboardingSurvey/onboardingSurveyDismissStorage'
import OnboardingSurveyModal from '../OnboardingSurvey/OnboardingSurveyModal'

const OnboardingSurveyGate = () => {
  const [token, setToken] = useState(null)
  const [userId, setUserId] = useState(null)
  const [pendingPayload, setPendingPayload] = useState(null)
  const [recheckTick, setRecheckTick] = useState(0)
  const [dismissTick, setDismissTick] = useState(0)

  useEffect(() => {
    const t = localStorage.getItem('token')
    setToken(t)
    if (t) {
      try {
        const decoded = jwt_decode(t)
        setUserId(decoded.user_id != null ? String(decoded.user_id) : null)
      } catch (e) {
        setUserId(null)
      }
    } else {
      setUserId(null)
    }
  }, [])

  const runCheck = useCallback(async () => {
    if (!localStorage.getItem('token')) {
      setPendingPayload(null)
      return
    }
    try {
      const res = await getPendingOnboardingSurvey()
      const d = res.data?.data
      if (d && d.pending === true && d.formUrl) {
        setPendingPayload(d)
      } else {
        setPendingPayload(null)
      }
    } catch (e) {
      console.warn('OnboardingSurveyGate: check failed, skipping modal', e)
      setPendingPayload(null)
    }
  }, [])

  useEffect(() => {
    if (!token) {
      return
    }
    runCheck()
  }, [token, recheckTick, runCheck])

  const handleCloseSuccess = () => {
    clearDismissedSurveyType(userId)
    setPendingPayload(null)
    setRecheckTick((n) => n + 1)
    pubsub.publish('onboardingSurveyCompleted')
  }

  useEffect(() => {
    const token = pubsub.subscribe('openOnboardingSurvey', () => {
      clearDismissedSurveyType(userId)
      setDismissTick((n) => n + 1)
    })
    return () => {
      pubsub.unsubscribe(token)
    }
  }, [userId])

  const handleDismiss = () => {
    if (pendingPayload?.surveyType) {
      setDismissedSurveyType(userId, pendingPayload.surveyType)
    }
    setDismissTick((n) => n + 1)
  }

  const dismissAllowed =
    pendingPayload == null || pendingPayload.dismissAllowed !== false

  const hiddenByUserDismiss = useMemo(() => {
    if (!pendingPayload) {
      return false
    }
    if (!dismissAllowed) {
      return false
    }
    return getDismissedSurveyType(userId) === pendingPayload.surveyType
  }, [pendingPayload, userId, dismissTick, dismissAllowed])

  const show =
    Boolean(pendingPayload) &&
    Boolean(pendingPayload.formUrl) &&
    !hiddenByUserDismiss

  return (
    <OnboardingSurveyModal
      open={show}
      pendingPayload={show ? pendingPayload : null}
      dismissAllowed={dismissAllowed}
      onCloseSuccess={handleCloseSuccess}
      onDismiss={handleDismiss}
    />
  )
}

export default OnboardingSurveyGate
